import script from "./YesNoPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./YesNoPopup.vue?vue&type=script&setup=true&lang=js"

import "./YesNoPopup.vue?vue&type=style&index=0&id=1f8587c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8587c8"]])

export default __exports__